import {
  TEXTURE_PATTERN_DOTS,
  TEXTURE_PATTERN_HEXAGONS,
  TEXTURE_PATTERN_STRIPES_CLOSE,
  TEXTURE_PATTERN_STRIPES_WIDE,
  TEXTURE_PATTERN_WOVEN,
} from "../textures/consts";

const SvgTextureDefsDefinitions = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <pattern id={TEXTURE_PATTERN_STRIPES_WIDE} patternUnits="userSpaceOnUse" width="18" height="18">
        <path d="M -4.5,18 l 9,-18 M 4.5,18 l 9,-18 M 13.5,18 l 9,-18" strokeWidth="1" shapeRendering="auto" stroke="black" strokeLinecap="square"></path>
      </pattern>
      <pattern id={TEXTURE_PATTERN_HEXAGONS} patternUnits="userSpaceOnUse" width="15.600000000000001" height="9.00666419935816">
        <path d="M 5.2,0 l 5.2,0 l 2.6,4.50333209967908 l -2.6,4.50333209967908 l -5.2,0 l -2.6,-4.50333209967908 Z M 0,4.50333209967908 l 2.6,0 M 15.600000000000001,4.50333209967908 l -2.6,0" fill="transparent" stroke="black" strokeWidth="1" strokeLinecap="square" shapeRendering="auto" />
      </pattern>
      <pattern id={TEXTURE_PATTERN_STRIPES_CLOSE} patternUnits="userSpaceOnUse" width="4.5" height="4.5">
        <path d="M 0,4.5 l 4.5,-4.5 M -1.125,1.125 l 2.25,-2.25 M 3.375,5.625 l 2.25,-2.25" strokeWidth="1" shapeRendering="auto" stroke="black" strokeLinecap="square" />
      </pattern>
      <pattern id={TEXTURE_PATTERN_DOTS} patternUnits="userSpaceOnUse" width="4.5" height="4.5">
        <circle cx="2.25" cy="2.25" r="1" fill="#343434" stroke="black" strokeWidth="0" />
      </pattern>
      <pattern id={TEXTURE_PATTERN_WOVEN} patternUnits="userSpaceOnUse" width="9" height="9">
        <path d="M 2.25,2.25l4.5,4.5M6.75,2.25l4.5,-4.5 M2.25,6.75l-4.5,4.5M6.75,11.25l4.5,-4.5 M-2.25,2.25l4.5,-4.5" fill="transparent" stroke="black" strokeWidth="1" strokeLinecap="square" shapeRendering="auto" />
      </pattern>
    </defs>
  </svg>
)

export { SvgTextureDefsDefinitions };


